module.exports = __webpack_public_path__ + "assets/951d02722bfb177e4ed48b83997d6052.jpg";